import { PropsWithChildren, ReactElement } from 'react'
import styles from 'components/features/coaching/advisorVideoCall/DeviceSelect/DeviceSelect.styl'
import { useSelect } from 'components/atoms/inputs/Select/useSelect'
import { SelectHandler } from 'components/atoms/inputs/Select/SelectHandler/SelectHandler'
import { DropdownPreset } from 'components/atoms/inputs/Select/DropdownPreset/DropdownPreset'
import { Option } from 'components/atoms/inputs/Select/parts/types'
import { TypeBufferHandler } from 'components/atoms/inputs/Select/TypeBufferHandler/TypeBufferHandler'
import { PlainSelectInput } from 'components/atoms/inputs/PlainSelectInput/PlainSelectInput'

type DeviceSelectProps<Value> = {
  options: Option<Value>[]
  value: Value
  placeholder?: string
  onChange: (value: Value | null) => void
}
export const DeviceSelect = <Value extends any>(props: PropsWithChildren<DeviceSelectProps<Value>>): ReactElement | null => {
  const {
    options,
    placeholder,
  } = props


  const selectContext = useSelect<Value>(props)
  const { isOpen, inputRef } = selectContext

  return (
    <SelectHandler context={ selectContext }>
      <TypeBufferHandler context={ selectContext } options={ options }>
        <div className={ styles.select }>
          <PlainSelectInput
            readOnly
            innerRef={ inputRef.set }
            className={ styles.labelInput }
            placeholder={ placeholder || 'Select' }
            autoComplete='no'
            isOpen={ isOpen.visible }
          />
          { isOpen.visible && (
            <div className={ styles.dropdown }>
              <DropdownPreset<Value> context={ selectContext } />
            </div>
          )}
        </div>
      </TypeBufferHandler>
    </SelectHandler>
  )
}
